// Shared design tokens for the Data Ingestion product.
// Import these instead of hardcoding colors/fonts so every page stays visually consistent.
 
export const tokens = {
    color: {
        primary: '#6D55B6',
        primaryDark: '#5B45A0',
        primaryTint: '#F2EEFB',
        success: '#1E8E5A',
        successTint: '#EAF7EF',
        danger: '#C0392B',
        dangerTint: '#FBEAEA',
        warning: '#B7791F',
        warningTint: '#FDF3E1',
        border: '#E5E7EB',
        borderStrong: '#D8DBE2',
        textPrimary: '#111827',
        textSecondary: '#6B7280',
        textMuted: '#9CA3AF',
        surface: '#FFFFFF',
        surfaceMuted: '#F9FAFB',
        canvas: '#F5F6F8',
        rail: '#1B1E2B'
    },
    font: {
        body: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        mono: "'JetBrains Mono', 'SFMono-Regular', ui-monospace, Menlo, Consolas, monospace"
    },
    radius: { sm: '6px', md: '8px', lg: '12px' }
};
 
export const sectionLabelStyle = {
    fontSize: '11px',
    fontWeight: 700,
    letterSpacing: '0.06em',
    textTransform: 'uppercase',
    color: tokens.color.textMuted
};
 
export const card = {
    backgroundColor: tokens.color.surface,
    border: `1px solid ${tokens.color.border}`,
    borderRadius: tokens.radius.lg,
    boxShadow: '0 1px 2px rgba(17, 24, 39, 0.04)'
};
 
export const cardHeader = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '18px 24px',
    borderBottom: `1px solid ${tokens.color.border}`
};